import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpendingPlanListComponent } from './components/spending-plan-list/spending-plan-list.component';
import {SpendingPlansRoutingModule} from "./spending-plans-routing.module";
import {TandemCoreModule} from "../tandem-core/tandem-core.module";
import {ReactiveFormsModule} from "@angular/forms";
import {SpendingPlanFormComponent} from "./components/spending-plan-form/spending-plan-form.component";
import {SpendingPlanGraphComponent} from "./components/spending-plan-graph/spending-plan-graph.component";
import {CreateSpendingPlanComponent} from "./components/create-spending-plan/create-spending-plan.component";
import {ViewSpendingPlanComponent} from "./components/view-spending-plan/view-spending-plan.component";
import {EditSpendingPlanComponent} from "./components/edit-spending-plan/edit-spending-plan.component";
import {NgxEchartsModule} from "ngx-echarts";
import {CashFlowsModule} from "../cash-flows/cash-flows.module";
import {TandemDatePipe} from "../tandem-core/directives/tandem-date.pipe";




@NgModule({
    declarations: [
        SpendingPlanListComponent,
        SpendingPlanFormComponent,
        SpendingPlanGraphComponent,
        CreateSpendingPlanComponent,
        EditSpendingPlanComponent,
        ViewSpendingPlanComponent
    ],
    exports: [
        SpendingPlanGraphComponent,
        SpendingPlanListComponent
    ],
    imports: [
        CommonModule,
        SpendingPlansRoutingModule,
        TandemCoreModule,
        ReactiveFormsModule,
        NgxEchartsModule,
        CashFlowsModule
    ],
  providers: [
    TandemDatePipe
  ]
})
export class SpendingPlansModule { }
